module.exports = __webpack_public_path__ + "img/txsp.0a3c6ee7.jpg";